// Import / export of builder formats as .json files, so a format can be moved
// between stores or kept as a backup.
//
// File shape: { kind: "zota-invoice-formats", version: 1, exported_at, formats: [{ name, type, template }] }
// A bare template (an object with `bands`) is accepted too.
import { normalizeTemplate } from "./schema";
import { DOC_TYPE_MAP } from "./doc-types";

const KIND = "zota-invoice-formats";

export function downloadFormats(formats, fileName) {
  const payload = {
    kind: KIND,
    version: 1,
    exported_at: new Date().toISOString(),
    formats: formats.map((t) => ({ name: t.name, type: t.docType, template: t })),
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${String(fileName || "invoice-formats").replace(/[^\w-]+/g, "_")}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

function readFile(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = () => reject(new Error(`Could not read ${file.name}`));
    r.readAsText(file);
  });
}

// Returns normalized templates found in the files. `fallbackType` is used for
// templates without a (known) document type.
export async function readFormatFiles(files, fallbackType) {
  const out = [];
  for (const file of Array.from(files || [])) {
    let data;
    try {
      data = JSON.parse(await readFile(file));
    } catch (e) {
      throw new Error(`${file.name} is not a valid format file`);
    }
    const items = data && data.kind === KIND && Array.isArray(data.formats) ? data.formats.map((f) => ({ ...f.template, name: f.name || f.template?.name, docType: f.type || f.template?.docType })) : [data];
    for (const t of items) {
      if (!t || !Array.isArray(t.bands)) throw new Error(`${file.name} is not an Invoice Builder format`);
      const docType = DOC_TYPE_MAP[t.docType] ? t.docType : fallbackType;
      out.push(normalizeTemplate({ ...t, docType, name: t.name || file.name.replace(/\.json$/i, "") }));
    }
  }
  return out;
}
